/**
 * src/main.js
 *
 * Punto de entrada de la aplicación.
 * Antes de renderizar, carga los datos dinámicos desde los JSON
 * publicados por el admin, para que el sitio siempre muestre
 * la información actualizada.
 */

import './style.css'
import config from './config/app.js'
import { logger } from './shared/utils/logger.js'
import '@components/index.js'
import { renderApp } from '@components/Component.js'
import { setBusinesses } from '@/db/businesses.db.js'
import { setPromos }     from '@/db/promos.db.js'
import { initAnalytics } from '@/services/analytics.js'

document.title = config.name

async function init() {
    try {
        const t = Date.now()
        const [bizRes, promoRes] = await Promise.all([
            fetch(`/data/businesses.json?t=${t}`),
            fetch(`/data/promos.json?t=${t}`),
        ])
        if (bizRes.ok)   { const d = await bizRes.json();   setBusinesses(d.items || []) }
        if (promoRes.ok) { const d = await promoRes.json(); setPromos(d) }
    } catch {
        // Si no hay servidor (dev sin JSON), usa los datos hardcodeados de .db.js
    }

    const appContainer = document.getElementById('app')
    if (appContainer) {
        renderApp('App', appContainer)
        initAnalytics()
    } else {
        logger.error('❌ No se encontró el contenedor #app')
    }
}

init()
